import { routing } from "../../routing.js";
import { Query } from "../../types/index.js";
export function createClient(api) {
  async function list(scope) {
    const {
      senders
    } = await api.get(routing.senderAddressesUrl, {
      query: {
        scope: Query.stringify(scope)
      }
    });
    return senders;
  }
  async function create(payload) {
    const {
      sender
    } = await api.post(routing.senderAddressesUrl, {
      payload
    });
    return sender;
  }
  async function get(senderId) {
    const {
      sender
    } = await api.get(`${routing.senderAddressesUrl}/${senderId}`);
    return sender;
  }
  async function update(senderId, payload) {
    const {
      sender
    } = await api.patch(`${routing.senderAddressesUrl}/${senderId}`, {
      payload
    });
    return sender;
  }
  async function doDelete(senderId) {
    return api.delete(`${routing.senderAddressesUrl}/${senderId}`);
  }
  return {
    list,
    create,
    get,
    update,
    delete: doDelete
  };
}